
import Vue from 'vue';
import MainLayout from '../components/MainLayout.vue';
import Component from 'vue-class-component';

@Component({
    components: {
        MainLayout,
    },
})
export default class NotFound extends Vue {

}
